
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 357 356","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.205 1.004C27.2 2.336 19.173 6.598 12.955 12.82 6.365 19.413 2.476 26.955 1.063 35.886-.365 44.907-.35 311 1.08 319.886c2.946 18.326 16.715 32.105 34.94 34.965 8.905 1.397 275.095 1.397 284 0 18.225-2.86 31.994-16.639 34.94-34.965 1.443-8.976 1.443-275.024 0-284-1.504-9.355-5.01-16.232-11.656-22.863-6.71-6.695-14.274-10.605-23.37-12.08C311.95-.354 43.011-.296 35.205 1.003zm283.243 36.453c1.413 1.414 1.571 15.577 1.571 140.965 0 136.791-.036 139.413-1.934 140.429-1.307.699-47.04 1.035-140.965 1.035-136.432 0-139.05-.036-140.066-1.934-.699-1.307-1.035-46.874-1.035-140.429 0-124.57.158-138.652 1.571-140.066 1.414-1.413 15.53-1.57 140.429-1.57 124.9 0 139.015.157 140.429 1.57zM68.519 252.093c-5.007 1.75-9.177 5.494-11.529 10.352-4.55 9.402-.53 21.116 8.97 26.131l4.44 2.345 108.723-.268 108.724-.267 4.259-3c2.343-1.65 5.345-5.025 6.673-7.5 4.986-9.297.998-21.571-8.667-26.673l-4.408-2.327-107.092.079c-71.935.053-108.078.423-110.093 1.128z"}})])
          )
        }
      }
    